import { ActionType, createAsyncAction } from "typesafe-actions";

import CustomMetric from "@mapmycustomers/shared/types/stackRank/CustomMetric";
import { OnlyRequiredFields } from "@mapmycustomers/shared/util/ts";

export const fetchCustomMetrics = createAsyncAction(
  "@stackRank/fetchCustomMetrics/request",
  "@stackRank/fetchCustomMetrics/success",
  "@stackRank/fetchCustomMetrics/failure"
)<void, CustomMetric[], void>();

export const createCustomMetric = createAsyncAction(
  "@stackRank/createCustomMetric/request",
  "@stackRank/createCustomMetric/success",
  "@stackRank/createCustomMetric/failure"
)<
  {
    customMetric: OnlyRequiredFields<CustomMetric, "aggs" | "name" | "tableName">;
    successCallback?: (customMetric: CustomMetric) => void;
  },
  CustomMetric,
  void
>();

export const updateCustomMetric = createAsyncAction(
  "@stackRank/updateCustomMetric/request",
  "@stackRank/updateCustomMetric/success",
  "@stackRank/updateCustomMetric/failure"
)<
  { customMetric: CustomMetric; successCallback?: (customMetric: CustomMetric) => void },
  CustomMetric,
  void
>();

export const deleteCustomMetric = createAsyncAction(
  "@stackRank/deleteCustomMetric/request",
  "@stackRank/deleteCustomMetric/success",
  "@stackRank/deleteCustomMetric/failure"
)<
  {
    customMetricId: CustomMetric["id"];
    successCallback?: (customMetricId: CustomMetric["id"]) => void;
  },
  CustomMetric["id"],
  void
>();

export type Actions = ActionType<
  | typeof createCustomMetric
  | typeof deleteCustomMetric
  | typeof fetchCustomMetrics
  | typeof updateCustomMetric
>;
